import { ALL_LOCATIONS } from 'constants/cubohActionBar';
import { Text } from '@mantine/core';

export function formatSelectTitle(parentLabel, childLabel) {
  if (parentLabel === ALL_LOCATIONS) return childLabel;
  return (
    <>
      <Text className="select__parent-label">{`${parentLabel} / `}</Text>
      <Text>{childLabel}</Text>
    </>
  );
}

export function treeData(options) {
  return options.map(option => ({
    key: option.value,
    value: option.value,
    title: option.label,
    readableTitle: option.label,
    address: option.address,
    fullTitle: option.label,
    children: option.children.map(child => ({
      key: child.value,
      value: child.value,
      title: child.label,
      fullTitle: formatSelectTitle(option.label, child.label),
      isLeaf: true,
      readableTitle: child.label,
      children: child.children?.map(grandChild => ({
        key: grandChild.value,
        value: grandChild.value,
        title: grandChild.label,
        isLeaf: true,
        readableTitle: grandChild.label,
        fullTitle: formatSelectTitle(child.label, grandChild.label),
      })),
    })),
  }));
}
const buildCompaniesAndMerchants = (companies, merchants) =>
  Object.values(companies).map(({ id: companyID, name, address, rest }) => {
    const companyMerchants = Object.values(merchants).filter(
      merchant => merchant.companyID === companyID,
    );
    return {
      id: companyID,
      value: JSON.stringify({ companyID }),
      label: name,
      address,
      children: companyMerchants.map(
            ({
              id: merchantID,
              name: merchantName,
              companyID: merchantCompanyID,
            }) => ({
              value: JSON.stringify({
                companyID: merchantCompanyID,
                merchantID,
              }),
              label: merchantName,
            }),
          ),
      ...rest,
    };
  });

export const buildMultiSelectOptions = (companies, merchants, userID, showAllLocations = false) => {
  let options = buildCompaniesAndMerchants(companies, merchants);
  if (Object.keys(companies ?? {}).length > 1 && showAllLocations) {
    options = [
      {
        id: userID,
        value: JSON.stringify({
          companyID: ALL_LOCATIONS,
          merchantID: null,
        }),
        label: ALL_LOCATIONS,
        name: ALL_LOCATIONS,
        children: options,
      },
    ];
  }
  return treeData(options);
};

export const buildSelectOptionsWithoutMerchants = companies => treeData(
    Object.values(companies ?? {}).map(({ id: companyID, name, address, rest }) => ({
      id: companyID,
      value: JSON.stringify({ companyID }),
      label: name,
      address,
      ...rest,
      children: [],
    })),
  );
